import { Navigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Role } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';
import { PageHeader } from '../molecules/PageHeader';
import SalesTadMargins from '../organisms/SalesTadMargins';

/**
 * PRO-1364 — Écran dédié C-Level : extraction de la marge mensuelle des Sales / TAD (export XLS).
 * Palliatif avant le calcul automatisé des commissions (milestone V3). Réservé au rôle System.
 */
const SalesTadMarginsPage = () => {
  const { t } = useTranslation(['salesTadMargins']);
  const auth = useAuthStore((state) => state.auth);
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;

  if (!isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  return (
    <Container>
      <PageHeader id="titleSalesTadMargins" title={t('title')} />
      <SalesTadMargins />
    </Container>
  );
};

export default SalesTadMarginsPage;

const Container = styled('div')(() => ({
  margin: 'auto',
  width: '90%',
}));
